/**
 * "1 reminder", "4 reminders" — the one place a count and its noun are joined.
 *
 * Studio had grown a local `n === 1 ? ... : ...` in every file, and the ones
 * that were missed shipped as "Create these 1 reminders", "1 reminders
 * scheduled" and "Reminder plan · 1 steps". Use this instead of writing the
 * ternary again, and never "guest(s)".
 */
export function plural(count: number, one: string, many: string = `${one}s`): string {
  return `${count} ${count === 1 ? one : many}`;
}

/** Just the noun: `pluralWord(1, 'is', 'are')` for a verb that has to agree. */
export function pluralWord(count: number, one: string, many: string = `${one}s`): string {
  return count === 1 ? one : many;
}
